import { Injectable } from '@angular/core';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AppConfigService {
	private appConfig;
	private http: HttpClient = new HttpClient(new HttpXhrBackend({
		build: () => new XMLHttpRequest()
	}));

	public loadAppConfig(): Observable<void> {
		return this.http.get('/assets/appconfig.json').pipe(
			tap((data) => {
				this.appConfig = data;
			}),
			map(() => null)
		);
	}

	public getConfig(): Config {
		return this.appConfig;
	}
}

interface Config {
	webApi: string;
	webApi2: string;
	baseHelpURL: string;
	psEmail: string;
	environment: 'development' | 'integration' | 'staging' | 'production';
	[key: string] : any;
}
